module.exports = __webpack_public_path__ + "img/mind-logo-cut.e215ca05.jpg";